import { render, staticRenderFns } from "./datareleas.vue?vue&type=template&id=77388c22&"
import script from "./datareleas.vue?vue&type=script&lang=js&"
export * from "./datareleas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports